import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import { type ProductDto } from './buildingBlock'
import type { UseService } from '@haskoning/js-api-authentication-management'

const serviceURL = API.BUILDING_BLOCK.PRODUCTS.INDEX
const importURL = API.BUILDING_BLOCK.PRODUCTS.IMPORT_EXCEL

export function useSearchProductBaseStore<T>(api: UseService, indexURL: string) {
  const searchLoading = ref<boolean>(false)
  const searchResults = ref<T[]>([]) as Ref<T[]>

  const searchProducts = async (projectEnvironmentDatabase: number | null, search: string) => {
    searchLoading.value = true
    const params = {
      environment_database: projectEnvironmentDatabase ? projectEnvironmentDatabase.toString() : '',
      search: search
    }
    const response = await api.service(indexURL).get(null, params)
    if (!Array.isArray(response)) {
      searchResults.value = []
      return searchResults.value
    }
    searchResults.value = response
    searchLoading.value = false
    return searchResults.value
  }

  const resetSearchState = () => {
    searchResults.value = []
    searchLoading.value = false
  }

  return {
    searchResults,
    searchLoading,
    searchProducts,
    resetSearchState
  }
}

export const useProductStore = defineStore('product', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<ProductDto>({ service: serviceURL, api })
  const searchProductBaseStore = useSearchProductBaseStore<ProductDto>(api, serviceURL)

  const updateFile = async (formData: FormData) => {
    const response = await api.service(importURL).post(formData)
    console.log(response)
  }

  return {
    ...baseStore,
    searchProductBaseStore,
    updateFile
  }
})
